import axios from 'axios';

const API = axios.create({
  baseURL: 'https://api.krukshop.ovh/api', // Adjust the baseURL to your backend server address
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to add the token to requests
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;